import React, { Component } from "react";
import Dialog from "../../../../dialogs/dialog.js";
import BaseErreurs from "../../../../../components/erreurs/erreurs.js"
import LanguageInput from "../../../../dialogs/languagesinput.js";

import { GlobalProvider } from "../../../../../utils/globalprovider.js";
import { directDownloadJson } from "../../utils.js";

import "./commonerrors.css"
import { getlocalhostDatas } from "../../../../../utils/apis.js";


class CommonErrors extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {
        fr:"Erreurs communes de transcription", 
        en:"Transcription common errors",
      };
    this.state.title = title;

    this.state.buttons = 
    [

      { type: 'text', disabled: false, text: { fr: "Export TXT", en: 'TXT export' }, key: "exportTXT" },
      { type: 'text', disabled: false, text: { fr: "Export JSON", en: 'JSON export' }, key: "exportJSON" },
      {type:"text", disabled:false,text:{fr:"Sauvegarder",en:"Save"},key:"save"},
      {type:"back", disabled:false},
      
      
    ]

    this.handleButton =  this.handleButton.bind(this);

    this.onQuit = this.onQuit.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.downloadDone = this.downloadDone.bind(this)

    this.baseErreursRef = React.createRef();
    
  }


componentDidMount()
{
  super.componentDidMount();
  
  directDownloadJson(
    getlocalhostDatas() + 'fr/common_errors_fra.json',
    this.downloadDone,
    'commonerrors'
  );

}
downloadDone(blob, infos, file) {
  if (this.baseErreursRef && this.baseErreursRef.current) {
    this.baseErreursRef.current.setCommonErrors(blob);
  }
}


componentWillUnmount()
{
}

componentDidUpdate()
{
  console.log("component did update ", this.state.title.fr)
}

  onQuit()
  {
    this.props.onButton("back");    
  }


  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)
    if (buttonkey === "back")
        this.props.onButton("back");
    
    if (buttonkey === "exportTXT") {
      this.baseErreursRef.current.exportText();
    }
    
    if (buttonkey === "exportJSON") {
      this.baseErreursRef.current.exportJson();
    }
  }

  render() {
    var maxwidth = (window.innerWidth * 55) / 100;
    if (maxwidth > 800) maxwidth = 800;

    var maxheight = (window.innerHeight * 82) / 100;
    if (maxheight > 500) maxheight = 500;

    const retour =
      (
        <div style={{ width: maxwidth, height: maxheight }}>
          <LanguageInput value="fr" />

          <div className="divcommonerrors">
            <GlobalProvider>

              <BaseErreurs ref={this.baseErreursRef} onSave={this.onSave} />
            </GlobalProvider>

          </div>
                        

        </div>
      )

    return super.render(retour);
  }


}


export default CommonErrors;